import type SlideModel from '../../../models/SlideModel';
import { requestAndParse, requestSuccessful } from '../request';

const getSlides = async (searchTerm?: string) => {
    const route = 'admin/get-slides';
    const payload = { searchTerm };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const slides = (response.body?.slides ?? []) as SlideModel[];

    return { success, slides };
};

export default getSlides;
